
import {ButtonBase, CircularProgress, Grid, Typography} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Boton_Fornulario = ({loading}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid item xs={12} sx={{pt: 0}}>
                <ButtonBase
                    type="submit"
                    variant="contained"
                    fullWidth

                    disabled={loading} // Desactiva el botón mientras carga
                    sx={{
                        backgroundColor: '#0082FB',
                        color: 'white',
                        p: 1,
                        opacity: loading ? 0.7 : 1,

                    }}
                >
                    {loading ? (
                        <CircularProgress size={24} sx={{color: "white"}} />
                    ) : (
                        <>
                            <Typography sx={{color: 'white', pr:2}}>Enviar</Typography>
                            <ArrowForwardIcon fontSize="small" />
                        </>
                    )}
                </ButtonBase>
            </Grid>
        </Grid>
    )

}
export default Boton_Fornulario;